import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import {
  Calendar, BookOpen, FlaskConical, MessageSquare, Building2, Newspaper, Link2, Sparkles, ArrowRight, Pin,
} from 'lucide-react';

export const REC_TYPE_META = {
  event: { label: 'Event', icon: Calendar, color: 'text-orange-500', bg: 'bg-orange-50' },
  course: { label: 'Course', icon: BookOpen, color: 'text-blue-500', bg: 'bg-blue-50' },
  britelab: { label: 'BriteLab', icon: FlaskConical, color: 'text-purple-500', bg: 'bg-purple-50' },
  forum_post: { label: 'Forum', icon: MessageSquare, color: 'text-brand-navy', bg: 'bg-brand-navy/5' },
  company: { label: 'Partner', icon: Building2, color: 'text-emerald-600', bg: 'bg-emerald-50' },
  news: { label: 'News', icon: Newspaper, color: 'text-rose-500', bg: 'bg-rose-50' },
  link: { label: 'Link', icon: Link2, color: 'text-amber-600', bg: 'bg-amber-50' },
};

const RecRow = ({ item }) => {
  const meta = REC_TYPE_META[item.item_type] || REC_TYPE_META.link;
  const Icon = meta.icon;
  const external = /^https?:\/\//.test(item.url || '');
  const body = (
    <div className="flex items-center gap-3 p-2.5 rounded-lg border border-slate-100 bg-white hover:shadow-sm hover:border-slate-200 transition-[box-shadow,border-color] h-full">
      <div className={`w-9 h-9 rounded-lg ${meta.bg} flex items-center justify-center flex-shrink-0`}>
        <Icon className={`h-4 w-4 ${meta.color}`} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5">
          <span className={`text-[9px] font-bold uppercase tracking-wider ${meta.color}`}>{meta.label}</span>
          {item.pinned && <Pin className="h-2.5 w-2.5 text-amber-500" data-testid={`rec-pinned-${item.key}`} />}
        </div>
        <p className="text-xs font-medium text-slate-700 truncate">{item.title}</p>
        <p className="text-[10px] text-slate-400 line-clamp-1">{item.reason || item.description}</p>
      </div>
      <ArrowRight className="h-3.5 w-3.5 text-slate-300 flex-shrink-0" />
    </div>
  );
  const common = { className: 'block', 'data-testid': `rec-item-${item.key}` };
  return external
    ? <a href={item.url} target="_blank" rel="noopener noreferrer" {...common}>{body}</a>
    : <Link to={item.url || '/'} {...common}>{body}</Link>;
};

export default function RecommendedForYou({ items }) {
  if (!items?.length) return null;
  return (
    <Card className="p-4 mt-3 border-0 shadow-sm bg-gradient-to-r from-white to-amber-50/40" data-testid="activity-recommendations">
      <h4 className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-3 flex items-center gap-1.5">
        <Sparkles className="h-3.5 w-3.5 text-amber-500" /> Recommended For You
      </h4>
      <div className="grid md:grid-cols-2 gap-3">
        {items.map(it => <RecRow key={it.key} item={it} />)}
      </div>
    </Card>
  );
}
